import algoliasearch from 'algoliasearch';

const CLIENT_APP_ID = process.env.REACT_APP_ALGOLIA_CLIENT_APP_ID as string;
const PUBLIC_API_KEY = process.env.REACT_APP_ALGOLIA_PUBLIC_API_KEY as string;

const searchClient = algoliasearch(CLIENT_APP_ID, PUBLIC_API_KEY);

const algoliaIconIndex = window.VenngageE2?.algoliaIndex?.iconsIndex ?? 'Icons v16';
const algoliaTemplatesIndex = window.VenngageE2?.algoliaIndex?.templatesIndex ?? 'Template-Production-Index-V12';

export const AlgoliaIndex = {
  Icon: algoliaIconIndex,
  Templates: algoliaTemplatesIndex,
} as const;

export const iconIndex = searchClient.initIndex(AlgoliaIndex.Icon);
export const templatesIndex = searchClient.initIndex(AlgoliaIndex.Templates);
